
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Die meisten starben in Alters- und Pflegeheimen, wo sich das Virus relativ
einfach ausbreiten kann, da dort viele Menschen auf engem Raum zusammenleben.
Die Pflegekräfte ziehen von Raum zu Raum und kommen in engen Kontakt mit den zu
Betreuenden. Trotz aller Vorsichtsmassnahmen habe sich das Virus eingenistet,
sagte Gabriela Bieri, Ärztliche Direktorin der Stadtzürcher Pflegezentren, Ende
April. Und sie gestand: «Wir waren etwas hilflos.»`}</p>
    <p>{`Im Kanton Zürich fielen bis heute von den 127 Todesfällen insgesamt 81 auf
Bewohner in Altersresidenzen, das sind 64 Prozent. In Genf wurden in 23 der 54
Altersheime Corona-Infektionen entdeckt. 109 starben insgesamt, das sind 41
Prozent aller Covid-19-Todesfälle im Kanton. Allerdings ist in Genf die
Heimversorgung vergleichsweise schlecht: Weil es zu wenig Plätze gibt, sind
viele Betagte in den Spitälern gestorben. In der Waadt sind insgesamt 240
Personen in Altersheimen gestorben so viele wie in keinem anderen Kanton.`}</p>
    <p>{`Schweizweit sind bis jetzt 927 Personen in Alters- und Pflegezentren an den
Folgen von Covid-19 verschieden, das sind 53 Prozent aller Corona-Todesfälle,
wie eine Anfrage bei den Kantonen ergab. Das Bundesamt für Gesundheit (BAG)
erfasst diese Fälle nicht zentral. Wir stützen unsere Zahlen auf Angaben aus 18
Kantonen, welche insgesamt 94 Prozent der Corona-Todesfälle in der Schweiz
verzeichnen. Nur drei Kantone (Basel-Stadt, Wallis und Zürich) geben in den
Statistiken auch an, wenn Bewohner von Altersresidenzen ins Spital verlegt
wurden und dort verstarben. Die anderen begnügen sich mit dem Sterbeort als
Datenerfassung. Darum dürfte die effektive Zahl der verstorbenen
Altersheimbewohner noch höher liegen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;